<template>
  <div class="hpanel notranslate" v-if="project" translate="no">
    <template v-if="type === 'result'">
      <div class="panel-heading">
        <div class="row">
          <div class="col-xs-12 col-md-12 col-lg-5">
            <div v-if="listType !== 'aichat'">
              Research results
            </div>
            <span ref="help">
                <button class="btn btn-info btn-xs" @click="showShareResult = true" title="Share these results with an email address" v-if="listType !== 'aichat'"><i class="fa fa-share-alt"></i> Share</button>
              <template v-if="listType !== 'company' && listType !== 'news' && listType !== 'aichat' && searchState === 2">
                <template v-if="$user.isBasic()">
                  <button v-if="followedSearchId" class="btn btn-info btn-xs" @click="unFollowSearch(followedSearchId)"><i class="fas fa-star"></i> UnMonitor</button>
                  <button id="monitor" v-else class="btn btn-outline btn-info btn-xs" @click="followSearch(query)" data-toggle="popover" :data-content="'Periodically replay this query. Go to My dashboard to manage'"><i class="far fa-star"></i> Monitor</button>
                </template>
                <template v-else>
                  <button v-if="followedSearchId" class="btn btn-info btn-xs" @click="unFollowSearch(followedSearchId)"><i class="fas fa-star"></i> UnMonitor</button>
                  <button id="monitor" v-else class="btn btn-outline btn-info btn-xs" @click="followSearch(query)" data-toggle="popover" :data-content="'Periodically replay this query. Go to Project overview to manage'"><i class="far fa-star"></i> Monitor</button>
                </template>
              </template>
              <button class="btn btn-info btn-xs" @click="listType === 'company' ? showModalCompanyTable = true : showModalScienceDataTable = true" title="Show table result" v-if="['company', 'author', 'patents'].includes(listType) && searchState === 2"><i class="fa fa-table"></i> Table</button>
            </span>
          </div>
          <div class="col-xs-12 col-md-12 col-lg-7 search-result-filters">
            <filters v-if="!overlay" :type="listType" :workflow-id="project.workflow_id" :context="context" :isFollowedSearch="followedSearchId !== null"></filters>
          </div>
        </div>
        <too-many-result-notification-box v-model="overlay" :is-simple-search="false"></too-many-result-notification-box>
      </div>
      <div class="panel-body no-padding">

        <template v-if="searchState === 0">
          <div class="panel-body">
            <div class="text-center">
              <h2 class="m-b-xs">Search Empty</h2>
              <div class="m">
                <i class="pe-7s-search fa-5x"></i>
              </div>
              <p class="small">
                For found the best experts in the word, use the search engine
              </p>
              <button class="btn btn-info btn-sm" @click="makeSearch">Make search</button>
            </div>
          </div>
        </template>
        <template v-else-if="searchState === 1">
          <div class="panel-body">
            <div class="text-center">
              <h2 class="m-b-xs">Search in Progress ...</h2>
              <div class="m">
                <div class="progress full m-t-xs" style="margin: 40px 0">
                  <div class="progress-bar progress-bar-striped active progress-bar-info" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%">
                  </div>
                </div>
              </div>
              <p class="small">
                we are exploring many databases around the world, it may take some time
              </p>
              <button class="btn btn-info btn-sm" @click="cancelSearch">Click to stop search</button>
            </div>
          </div>
        </template>
        <template v-else-if="searchState === 2">
          <template v-if="Object.entries(items).length === 0 || !context.hasItemsToDisplay">
            <div class="panel-body">
              <div class="text-center">
                <h2 class="m-b-xs" v-if="listType !== 'company'">Whoops</h2>
                <div class="m">
                  <i class="fa fa-exclamation-triangle fa-5x"></i>
                </div>
                <template v-if="listType === 'company' && companyNotification === true">
                 <span class="text-center m-b-lg m">
                   <h3><i class="fa fa-exclamation-triangle fa-1x"></i> The service is temporarily limited, sorry for the inconvenience.</h3>
                   <h4> <a @click="openSupport()" class="text-info"> Contact us </a> through the assistance in case of emergency.</h4>
                 </span>
                </template>
                <template v-else>
                  <div class="text-left" style="display: inline-block;margin-top: 15px">
                    <h5 style="font-size:18px;">No results, you may :</h5>
                    <ul style="list-style: inside;margin-top: 10px;font-size:16px;">
                      <li>Check your query spelling</li>
                      <li>Remove one or more keywords from your query</li>
                      <li>Watch our <a href="https://academy.idexlab.com/hc/en-us/articles/360002852879-Query-advices" class="text-info" target="_blank" >tutorials</a></li>
                      <li><a @click="openSupport()" >Contact support for help</a></li>
                    </ul>
                  </div>
                  <div class="text-center" style="display: block;margin-top: 15px" >
                    <button class="btn btn-info btn-sm" @click="makeSearch">Refine search</button>
                  </div>
                </template>
              </div>
            </div>
          </template>
          <template v-else-if="similar !== null && selected !== null">
            <div class="overlay text-center expert-overlay" v-if="overlay">
              <div style="margin: 150px 0">
                <div class="m">

                </div>
              </div>
            </div>

            <template v-if="project && project.workflow_id === 1 && (listType === 'author' || listType === 'patents')">
              <list-authors v-if="listType === 'author' || listType === 'patents'" ref="listAuthors"
                            :allAuthors="items" :listId="listId" :authorsSimilar="similar"
                            :authorsSelected="selected" :biblio="biblio"
                            :nbEstimateExperts="nbEstimateItems"
                            :searchState="searchState" :listType="listType" :searchType="searchType"
                            :project="project"
                            :nbSearchCompanies="nbSearchCompanies"
                            @updatePubDate="updatePubDate" @updateCountries="updateCountries"
                            @updateItem="updateItem"
                            :style="{minHeight: documentsHeight}"
                            :context="context"
                            :type="'result'"
                            :followedSearches="followedSearches">
              </list-authors>
            </template>
            <template v-else-if="project">
              <list-authors v-if="listType === 'author' || listType === 'patents'" ref="listAuthors"
                            :allAuthors="items" :listId="listId" :authorsSimilar="similar"
                            :authorsSelected="selected" :biblio="biblio"
                            :nbEstimateExperts="nbEstimateItems"
                            :searchState="searchState" :listType="listType" :searchType="searchType"
                            :project="project"
                            :nbSearchCompanies="nbSearchCompanies"
                            @updatePubDate="updatePubDate" @updateCountries="updateCountries"
                            @updateItem="updateItem"
                            :style="{minHeight: documentsHeight}"
                            :context="context"
                            :type="'result'"
                            :followedSearches="followedSearches">
              </list-authors>
              <list-companies v-else-if="listType === 'company'" ref="listCompanies"
                              :allCompanies="items" :listId="listId" :companiesSimilar="similar"
                              :companiesSelected="selected" :biblio="biblio"
                              :nbEstimateCompanies="nbEstimateItems"
                              :searchState="searchState" :listType="listType" :searchType="searchType"
                              :project="project"
                              @updateCountries="updateCountries"
                              :style="{minHeight: documentsHeight}"
                              :context="context"
                              :type="'result'">

              </list-companies>
                <list-news v-else-if="listType === 'news'"
                                :allNews="items" :listId="listId"  :biblio="biblio"
                                :nbEstimateNews="nbEstimateItems"
                                :searchState="searchState" :listType="listType" :searchType="searchType"
                                :project="project"
                                :style="{minHeight: documentsHeight}"
                                :context="context"
                                :type="'result'">

                </list-news>
                <list-a-i v-else-if="listType === 'aichat'"
                                :result="items" :listId="listId"  :biblio="biblio"
                                :searchState="searchState" :listType="listType" :searchType="searchType"
                                :project="project"
                                :style="{minHeight: documentsHeight}"
                                :context="context"
                                :type="'result'">
                </list-a-i>

            </template>
          </template>

        </template>
      </div>
    </template>
    <template v-else-if="listType === 'author' || listType === 'patents'">
      <list-authors :allAuthors="items" :listId="listId" :biblio="biblio"
                    :project="project" :context="context" :type="type" :listType="listType" :followedSearches="followedSearches"/>

    </template>
    <template v-else-if="listType === 'company'">
      <list-companies :allCompanies="items" :listId="listId" :biblio="biblio"
                      :project="project" :context="context" :type="type" :listType="listType"/>

    </template>
    <template v-if="showShareResult === true">
      <share-search-result v-model="showShareResult"></share-search-result>
    </template>
    <template v-if="showModalCompanyTable === true">
      <modal-company-table v-model="showModalCompanyTable" :allCompanies="items"></modal-company-table>
    </template>
    <template v-if="showModalScienceDataTable === true">
      <modal-science-data-table v-model="showModalScienceDataTable" :allAuthors="items" :dataType="listType"></modal-science-data-table>
    </template>
  </div>

</template>

<style>
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 500;
    width: 100%;
    height: 100%;
    display: block;
    background: #f8f9fb;
    opacity: 0.8;
  }

  .br-theme-bars-horizontal .br-widget {
    height: auto !important;
    margin: auto !important;
  }

  .br-theme-bars-horizontal .br-widget a, .br-theme-bars-horizontal .br-widget {
    width: 25px !important;
  }

  .top-document {
    cursor: pointer;
    /*max-height: 80px;*/
    padding: 15px 0;
    border-bottom: 1px solid #eaeaea;
  }
  .top-document:hover {
    background: #f5f5f5;
  }
</style>
<script>

import ListDocuments from '../ListDocuments/ListDocuments'
import ListAffiliations from '../ListAffiliations/ListAffiliations'
import ListAuthors from '../ListAuthors/ListAuthors'
import ListCompanies from '../ListCompanies/ListCompanies'
import ListNews from '../ListNews/ListNews'
import ListAI from '../ListAI/ListAI'
import Filters from '../filter/Filters'
import {Parser} from 'json2csv'
import TooManyResultNotificationBox from '../search/TooManyResultNotificationBox'
import ShareSearchResult from '../modal/ShareSearchResult'
import ModalCompanyTable from '../modal/CompanyTable.vue'
import ModalScienceDataTable from '../modal/ScienceDataTable.vue'
import {cleanQueryFromTagsinputToSearch} from '../../assets/scripts/search'
import FollowSearch from '../Mixins/FollowSearch'

export default {
  mixins: [FollowSearch],
  components: {
    ShareSearchResult,
    ModalCompanyTable,
    ModalScienceDataTable,
    Filters,
    ListCompanies,
    ListAuthors,
    ListAffiliations,
    ListDocuments,
    ListNews,
    ListAI,
    TooManyResultNotificationBox
  },
  props: ['project', 'listType', 'items', 'similar', 'selected', 'searchCountries', 'listId', 'type',
    'nbSearchCompanies', 'biblio', 'nbResults', 'totalNbResults', 'searchType', 'searchState', 'query', 'showLimitPlan',
    'projectsLists', 'followedSearches'],
  name: 'ListIdexlab',
  data () {
    return {
      documentsHeight: 'auto',
      overlay: false,
      nbEstimateItems: 0,
      followedSearchId: null,
      companyNotification: process.env.SHOW_COMPANY_WARNING,
      context: {
        listId: null,
        biblioId: null,
        workflowId: null,
        name: null,
        affiliationsFilter: [],
        affiliationsSelected: [],
        countriesFilter: [],
        countriesSelected: [],
        pubDateFilter: [],
        pubDateSelected: [],
        categoryFilter: [],
        categorySelected: [],
        expertSourceFilter: [],
        expertSourceSelected: [],
        publicationFilter: [],
        publicationsSelected: [],
        affiliationTypeFilter: [],
        affiliationTypeSelected: [],
        dateIncorporateFilter: [],
        dateIncorporateSelected: [],
        followedSearchFilter: [],
        newDocumentsSelected: [],
        newDocumentsFilter: [],
        newsDateFilter: [],
        newsDateSelected: [],
        newsProviderFilter: [],
        newsProviderSelected: [],
        filterSelected: null,
        nbItemsDisplay: 25,
        changeSort: this.changeSort,
        displayMore: this.displayMore,
        displayAll: this.displayAll,
        addDocumentToBiblio: this.addDocumentToBiblio,
        addAiChatToBiblio: this.addAiChatToBiblio,
        citeDocument: this.citeDocument,
        shareDocument: this.shareDocument,
        addAuthor: this.addItem,
        removeAuthor: this.removeItem,
        addAuthorSimilar: this.addItemSimilar,
        searchAuthorByName: this.searchByName,
        addCompany: this.addItem,
        removeCompany: this.removeItem,
        mergeCompany: this.mergeItem,
        addCompanySimilar: this.addItemSimilar,
        followSearch: this.followSearch,
        unFollowSearch: this.unFollowSearch,
        showLimitPlan: this.showLimitPlan,
        exportCsv: this.exportCsv,
        copyToList: this.copyToList,
        selected: [],
        projectsLists: [],
        hasItemsToDisplay: true
      },
      showShareResult: false,
      showModalCompanyTable: false,
      showModalScienceDataTable: false
    }
  },
  watch: {
    project: function (val) {
      if (val !== null) {
        this.context.workflowId = val.workflow_id
      }
    },
    searchState: function (val) {
      if (val === 2) {
        if (this.items.length !== 0 && this.items.length !== 0 && this.totalNbResults !== 0) {
          this.context.affiliationsFilter = []
          this.context.countriesFilter = []
          this.context.pubDateFilter = []
          this.context.categoryFilter = []
          this.context.expertSourceFilter = []
          this.context.publicationFilter = []
          this.context.affiliationTypeFilter = []
          this.context.dateIncorporateFilter = []
          this.context.newsDateFilter = []
          this.context.newsProviderFilter = []

          this.context.affiliationsSelected = []
          this.context.countriesSelected = this.getSearchCountries()
          this.context.pubDateSelected = []
          this.context.categorySelected = []
          this.context.expertSourceSelected = []
          this.context.publicationsSelected = []
          this.context.affiliationTypeSelected = []
          this.context.dateIncorporateSelected = []
          this.context.newsProviderSelected = []
          this.context.newsDateSelected = []
          this.context.nbItemsDisplay = 25
          this.context.hasItemsToDisplay = true

          this.estimateItems()
          setTimeout(() => {
            if (typeof this.$refs.help !== 'undefined') {
              $(this.$refs.help).find('[data-toggle="popover"]').popover({
                trigger: 'hover',
                placement: 'top'
              })
            }

            this.$eventHub.$emit('tourCanStart', true)
          }, 1000)
          setTimeout(() => {
            this.getMissingCompaniesInformations()
            this.getAffiliations()
          }, 10000)
        }
        // if (this.searchResult.suggestions.length !== 0) {
        //   this.documentsHeight = this.suggestionHeight + 120 + 'px'
        // }
      }
    },
    listId: function (listId) {
      this.context.listId = listId
    },
    selected (val) {
      this.context.selected = val
    },
    followedSearches: function (followedSearches) {
      if (typeof this.query !== 'undefined') {
        let query = cleanQueryFromTagsinputToSearch(this.query).toLowerCase()
        let followedSearchId = null

        followedSearches.forEach((search) => {
          if (search.search_terms.term === query && (
            (search.search_type === 0 && this.listType === 'author') ||
              (search.search_type === 1 && this.listType === 'patents'))) {
            followedSearchId = search.id
          }
        })
        this.followedSearchId = followedSearchId
      }
    },
    projectsLists (val) {
      this.context.projectsLists = val
    }
  },
  methods: {
    estimateItems: function () {
      if (this.totalNbResults && this.items.length >= this.nbResults && this.items.length > 100) {
        let factor = this.items.length / this.nbResults

        this.nbEstimateItems = Math.round(factor * this.totalNbResults)

        this.overlay = (this.listType !== 'news' && this.listType !== 'aichat' && this.nbEstimateItems >= 60000)
      } else {
        this.nbEstimateItems = (this.listType !== 'news' && this.listType !== 'aichat') ? this.bestExperts(this.items) : this.items.length
      }
      return this.nbEstimateItems.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    },
    bestExperts: function (authors) {
      let nbAuthorsNotDisplay = 0

      authors.forEach((author) => {
        nbAuthorsNotDisplay += (author.display === false) ? 1 : 0
      })

      let nb = authors.length - nbAuthorsNotDisplay
      return nb < 0 ? 0 : nb
    },
    getMissingCompaniesInformations: function () {
      if (this.listType === 'company' && this.overlay === false) {
        this.$notify({
          title: 'Complete missing informations',
          icon: 'fa fa-refresh pe-spin pe-7s',
          duration: 20000,
          placement: 'bottom-right'
        })

        let prompt = '[%prompt_company_complete%]'

        let companySearchAffilation = []
        if (this.items) {
          this.items.forEach(company => {
            if ((company.docs[0] && company.docs[0].sourceID === 11) || company.source_id === 11) {
              companySearchAffilation.push({ id: company.authorID, name: company.lastName })
            }
          })

          if (companySearchAffilation.length) {
            const chunks = []
            for (let i = 0; i < companySearchAffilation.length; i += 10) {
              chunks.push(companySearchAffilation.slice(i, i + 10))
            }

            chunks.forEach((chunk, index) => {
              const currentPrompt = prompt + JSON.stringify(chunk)

              let modulo = index % this.$proxies.length
              let domain = this.$proxies[modulo]

              this.$requestStack.add('post', domain + '/search/chatai/prompt', { prompt: currentPrompt }, 1)
                .then((response) => {
                  if (response.data) {
                    let resp = response.data.aichat
                    if (resp) {
                      const parsedResponse = JSON.parse(resp.replace(/```json/g, '').replace(/```/g, ''))
                      this.items.forEach(company => {
                        parsedResponse.forEach(searchAffilation => {
                          if (company.authorID === searchAffilation.id) {
                            if (!company.affiliation.status_str && searchAffilation.status) {
                              company.affiliation.status_str = searchAffilation.status
                            }
                            if (!company.affiliation.city && searchAffilation.city_of_headquarters) {
                              company.affiliation.city = searchAffilation.city_of_headquarters
                            }
                            if (!company.affiliation.country && searchAffilation.country_code) {
                              company.affiliation.country = searchAffilation.country_code
                            }
                            if (!company.affiliation.incorporation_date && searchAffilation.incorporation_year) {
                              company.affiliation.incorporation_date = searchAffilation.incorporation_year
                            }
                            if (!company.affiliation.nb_employees && searchAffilation.number_of_employees) {
                              company.affiliation.nb_employees = searchAffilation.number_of_employees
                            }
                            if (!company.affiliation.category && searchAffilation.company_type) {
                              company.affiliation.category = searchAffilation.company_type
                            }
                            if (!company.affiliation.url && searchAffilation.website) {
                              company.affiliation.url = searchAffilation.website
                            }
                            if (!company.affiliation.nb_patents && searchAffilation.number_of_patents) {
                              company.affiliation.nb_patents = searchAffilation.number_of_patents
                            }
                            if (!company.affiliation.overview && searchAffilation.overview) {
                              company.affiliation.overview = searchAffilation.overview
                            }
                            if (!company.affiliation.turnover && searchAffilation.last_known_annual_turnover) {
                              company.affiliation.turnover = searchAffilation.last_known_annual_turnover
                            }
                          }
                        })
                      })
                    }
                  }
                  this.$notify({
                    type: 'success',
                    title: 'Missing information completed',
                    placement: 'bottom-right'
                  })
                })
                .catch((_error) => {
                  this.$notify({
                    type: 'warning',
                    title: 'Error with AI execution query please try again',
                    placement: 'bottom-right'
                  })
                })
            })
          }
        }
      }
    },
    getAffiliations: function () {
      if (this.listType === 'author' && this.overlay === false) {
        this.$notify({
          title: 'Searching experts affiliations',
          icon: 'fa fa-refresh pe-spin pe-7s',
          duration: 20000,
          placement: 'bottom-right'
        })

        let authorsSearchAffiliation = []

        this.$refs.listAuthors.authors.forEach((author, index) => {
          if (index >= this.context.nbItemsDisplay) {
            return false
          } else if (author.affiliationSearched !== true && author.display === true) {
            author.affiliationSearched = true
            if (typeof author.expertSource === 'undefined' || (author.expertSource !== 'TECHNICAL EDISON' &&
              author.expertSource !== 'BICWORLD')) {
              authorsSearchAffiliation.push(author)
            }
          }
        })

        if (authorsSearchAffiliation.length !== 0) {
          authorsSearchAffiliation.forEach((author, index) => {
            let modulo = index % this.$proxies.length

            let domain = this.$proxies[modulo]

            this.$requestStack.add('get', domain + '/harvest/authors/' + author.authorID + '/affiliations/', null, 3)
              .then((response) => {
                author.affiliation = response.data
              })
              .catch((error) => {
              }).finally(() => {
                if (typeof this.$refs.listDocuments !== 'undefined' || typeof this.$refs.listAuthors !== 'undefined') {
                  if ((index !== 0 && index % 10 === 0) || typeof authorsSearchAffiliation[index + 1] === 'undefined') {
                    setTimeout(() => {
                      if (typeof this.$refs.listDocuments !== 'undefined' || typeof this.$refs.listAuthors !== 'undefined') {
                        if (this.project.workflow_id === 1 && typeof this.$refs.listDocuments !== 'undefined') {
                          this.$refs.listDocuments.initDocuments()
                        } else if (typeof this.$refs.listAuthors !== 'undefined') {
                          this.$refs.listAuthors.initAuthors()
                        }
                      }
                    }, 5000)
                  }
                }
              })
          })
        }
      }
    },
    updatePubDate: function (val) {
      this.$emit('updatePubDate', val)
    },
    updateCountries: function (val) {
      this.$emit('updateCountries', val)
    },
    addDocumentToBiblio: function (document, boxName = null) {
      let boxUrl
      if (!boxName) {
        if (typeof this.query === 'undefined') {
          boxName = document.keywords.replace(/[\.,'\/#!?|$%\^"&\*;:{><}=\_`~(),]/g, '')
          boxUrl = '/search/' + document.keywords
        } else {
          boxName = this.query.split(',')
          boxName = boxName[boxName.length - 1].replace(/[\.,'\/#!?|$%\^"&\*;:{><}=\_`~(),]/g, '')
          boxUrl = this.$router.currentRoute.fullPath.replace('&filters=%7B%22newDocs%22%3A%22new%22%7D', '')
        }
      }
      this.$requestStack.add('post', '/biblio/' + this.biblio.id + '/add/document', {
        url: boxUrl,
        name: boxName,
        document_id: document.documentID,
        document_dt: document.pubDate,
        document_title: document.title,
        document_source: document.publication,
        document_link: document.link,
        document_type: this.listType,
        document_authors: document.co_authors.map((author) => {
          return author.lastName + ' ' + author.firstName
        }).join(', '),
        document_abstract: document.abstract,
        document_doi: document.doi,
        document_authors_details: JSON.stringify(document.co_authors),
        isCopyTo: document.isCopyTo ? document.isCopyTo : false
      }, 0).then((response) => {
        this.$eventHub.$emit('refreshBiblio', true)
        this.$notify({
          type: 'success',
          title: 'Document added to Biblio',
          placement: 'bottom-right'
        })
        this.$salesMachine.addDocToBiblio({document: document})
      })
        .catch((error) => {
          this.$notify({
            type: 'danger',
            title: 'An error has occurred',
            content: 'We are sorry but we encountered an error, please refresh your page or contact support!',
            placement: 'bottom-right'
          })
        })
    },
    addAiChatToBiblio: function (aichatComment, keywordId) {
      this.$eventHub.$emit('addAiChatCommentToBiblio', {'aichat': aichatComment, 'keyId': keywordId})
    },
    shareDocument: function (document) {
      this.$notify({
        type: 'warning',
        title: 'Not implemented',
        placement: 'bottom-right'
      })
    },
    citeDocument: function (document) {
      this.$notify({
        type: 'warning',
        title: 'Not implemented',
        placement: 'bottom-right'
      })
    },
    getDataForQueryAddAuthor: function (author, withSimilar = false, type) {
      let data = []
      data.push({
        author_id: author.authorID,
        documents: author.docs.map((document) => {
          return document.documentID
        }),
        score: author.score,
        search_terms: this.query,
        is_suggested: false,
        external_expert_suggestion_id: null,
        type: type // company or author
      })

      if (author.similar_authors.length !== 0) {
        let similarCompanyAuthors = []
        this.items.forEach((tmpAuthor) => {
          author.similar_authors.forEach((tmpAuthorId) => {
            if (tmpAuthor.authorID === tmpAuthorId) {
              similarCompanyAuthors.push(tmpAuthor)
            }
          })
        })

        if (similarCompanyAuthors.length !== 0) {
          similarCompanyAuthors.forEach((similarAuthor) => {
            data.push({
              author_id: similarAuthor.authorID,
              documents: similarAuthor.docs.map((document) => {
                return document.documentID
              }),
              score: similarAuthor.score,
              search_terms: this.query,
              is_suggested: !withSimilar,
              external_expert_suggestion_id: author.authorID,
              type: type // company or author
            })
          })
        }
      }
      return data
    },
    getSearchCountries: function () {
      let countries = []

      if (typeof this.searchCountries !== 'undefined' && this.searchCountries.length !== 0) {
        this.searchCountries.forEach((searchCountry) => {
          countries.push({name: searchCountry, nb: 0})
        })
      }
      return countries
    },
    addItem: function (author, type) {
      if (this.$user.isBasic()) {
        this.showLimitPlan('addExpert')
      } else {
        if (this.type === 'similar') {
          this.$requestStack.add('patch', '/list/' + this.listId + '/author/' + author.authorID,
            {is_suggested: false}, 0)
            .then((response) => {
              this.$eventHub.$emit('updateCompanyAuthorList', true)

              this.$notify({
                type: 'success',
                title: 'Well done!',
                content: 'Authors moved to selected experts List',
                placement: 'bottom-right'
              })

              this.$salesMachine.addItem({author: author, type: type})
            })
            .catch((error) => {

            })
        } else {
          this.$requestStack.add('post', '/list/' + this.listId + '/author/',
            this.getDataForQueryAddAuthor(author, false, type), 0)
            .then((response) => {
              this.$eventHub.$emit('updateCompanyAuthorList', true)

              this.$notify({
                type: 'success',
                title: 'Well done!',
                content: 'Authors added in your list',
                placement: 'bottom-right'
              })

              this.$salesMachine.addItem({author: author, type: type})
            })
            .catch((error) => {

            })
        }
      }
    },
    addItemSimilar: function (author, type) {
      if (this.$user.isBasic()) {
        this.showLimitPlan('addExpert')
      } else {
        this.$requestStack.add('post', '/list/' + this.listId + '/author/',
          this.getDataForQueryAddAuthor(author, true, type), 0)
          .then((response) => {
            this.$eventHub.$emit('updateCompanyAuthorList', true)
            this.$notify({
              type: 'success',
              title: 'Added !',
              content: 'Expert and similar added to your list',
              placement: 'bottom-right'
            })
            this.$salesMachine.addItem({author: author, type: type})
          })
          .catch((error) => {

          })
      }
    },
    removeItem: function (author) {
      if (this.$user.isBasic()) {
        this.showLimitPlan('removeExpert')
      } else {
        this.$requestStack.add('delete', '/list/' + this.listId + '/author/' + author.authorID, null, 0)
          .then((response) => {
            this.$eventHub.$emit('updateCompanyAuthorList', true)
            this.$notify({
              type: 'success',
              title: 'Well done!',
              content: 'Author removed',
              placement: 'bottom-right'
            })

            this.$salesMachine.removeItem({author: author})
          })
          .catch((error) => {
            if (error.response.data.code === 3) {
              this.$notify({
                type: 'danger',
                title: 'You can not delete this author or this company because it is present in a mailing',
                placement: 'bottom-right'
              })
            }
          })
      }
    },
    copyToList: function (author, copyToListId) {
      this.$requestStack.add('post', '/list/' + this.listId + '/author/' + author.authorID + '/copy/' + copyToListId, null, 0)
        .then((response) => {
          this.$notify({
            type: 'success',
            title: 'Well done!',
            content: (author.firstName ? author.firstName + ' ' : '') + author.lastName + ' copied to selected Subproject',
            placement: 'bottom-right'
          })
        })
        .catch((error) => {
          if (typeof error.response !== 'undefined' && error.response.data.status === 400) {
            this.$notify({
              type: 'warning',
              content: (author.firstName ? author.firstName + ' ' : '') + author.lastName + ' already saved in the selected subproject',
              placement: 'bottom-right'
            })
          } else {
            this.$notify({
              type: 'danger',
              title: 'Item or list not exist!',
              placement: 'bottom-right'
            })
          }
        })
    },
    updateItem: function (author) {
      if (this.$user.isBasic()) {
        this.showLimitPlan('editExpert')
      } else {
        let localAuthor = this.items.find((localAuthor) => {
          return localAuthor.authorID === author.authorID
        })

        if (typeof localAuthor !== 'undefined') {
          localAuthor.affiliationSearched = author.affiliationSearched

          if (typeof author.affiliation !== 'undefined') {
            localAuthor.affiliation = author.affiliation
            // this.initAuthors()
          }
        }
      }
    },
    mergeItem: function (author, authorMerge) {
      if (this.$user.isBasic()) {
        this.showLimitPlan('mergeExpert')
      } else {
        this.$requestStack.add('patch', '/list/' + this.listId + '/company/' + author.authorID + '/merge/' + authorMerge.authorID, null, 0)
          .then((response) => {
            this.$notify({
              type: 'success',
              title: 'Well done!',
              content: 'Company replaced',
              placement: 'bottom-right'
            })
            this.$eventHub.$emit('updateCompanyAuthorList', new Date())
            this.$salesMachine.mergeItem({author: author})
          })
          .catch((error) => {
            this.$notify({
              type: 'danger',
              title: 'You can not replace this company',
              placement: 'bottom-right'
            })
          })
      }
    },
    displayMore: function (e) {
      e.preventDefault()
      this.context.nbItemsDisplay += 10

      if (this.context.name === 'expertResult') {
        setTimeout(() => { this.getAffiliations() }, 3000)
      }
    },
    displayAll: function (e) {
      e.preventDefault()

      this.$notify({
        type: 'warning',
        title: 'Display all',
        content: 'Can be slow with a lot of experts and take a lot of resources',
        placement: 'bottom-right'
      })
      this.context.nbItemsDisplay = this.items.length

      if (this.context.name === 'expertResult') {
        setTimeout(() => { this.getAffiliations() }, 7000)
      }
    },
    makeSearch: function (e) {
      e.preventDefault()
      window.scrollTo(0, 0)
    },
    cancelSearch: function (e) {
      e.preventDefault()
      this.$eventHub.$emit('cancelSearch', true)
    },
    searchByName: function (author) {
      this.$eventHub.$emit('searchByName', author)
    },
    exportCsv: function (type) {
      let documents = []
      let filename
      let fields

      let list = this.project.lists.find((list) => {
        return list.id === this.listId
      })

      if (type === 'author') {
        this.items.forEach((item) => {
          item.docs.forEach((doc) => {
            documents.push({
              fistName: item.firstName,
              lastName: item.lastName,
              organisationName: typeof item.affiliation !== 'undefined' ? item.affiliation.organisationName : '',
              organisationCity: typeof item.affiliation !== 'undefined' ? item.affiliation.city : '',
              organisationCountry: typeof item.affiliation !== 'undefined' ? item.affiliation.country : '',
              title: doc.title,
              abstract: doc.abstract,
              date: moment(doc.pubDate).year(),
              keywords: doc.keywords
            })
          })
        })

        filename = 'export-experts-' + list.title
        fields = ['firstName', 'lastName', 'organisationName', 'organisationCity', 'organisationCountry', 'title', 'abstract', 'date', 'keywords']
      } else {
        this.items.forEach((item) => {
          item.docs.forEach((doc) => {
            documents.push({
              organisationName: typeof item.affiliation !== 'undefined' ? item.affiliation.organisationName : '',
              organisationCity: typeof item.affiliation !== 'undefined' ? item.affiliation.city : '',
              organisationCountry: typeof item.affiliation !== 'undefined' ? item.affiliation.country : '',
              title: doc.title,
              abstract: doc.abstract,
              date: moment(doc.pubDate).year(),
              keywords: doc.keywords
            })
          })
        })

        filename = 'export-companies-' + list.title
        fields = ['organisationName', 'organisationCity', 'organisationCountry', 'title', 'abstract', 'date', 'keywords']
      }

      const opts = { fields }

      let json2csvParser = new Parser({opts, delimiter: ';'})
      let csv = json2csvParser.parse(documents)

      let element = document.createElement('a')

      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csv))
      element.setAttribute('download', filename + '.csv')

      element.style.display = 'none'
      document.body.appendChild(element)

      element.click()

      document.body.removeChild(element)
      this.$salesMachine.exportCsvExpertList({list: csv})
    },
    openSupport: function () {
      let iframe = document.getElementById('launcher')
      let supportButton = iframe.contentWindow.document.querySelector('#Embed button')

      if (typeof supportButton !== 'undefined') {
        supportButton.click()
      }
    },
    followSearch: function (query) {
      this.mixinFollowSearch(query, this.listType, this.listId)
    },
    unFollowSearch: function (followSearchId) {
      this.mixinUnFollowSearch(followSearchId)
    }
  },
  beforeMount () {
    this.context.workflowId = this.project !== null ? this.project.workflow_id : null
    this.context.projectsLists = this.projectsLists

    switch (this.type) {
      case 'similar':
        this.context.name = 'expertSimilar'
        break
      case 'selected':
        this.context.name = 'expertSelected'
        break
      case 'result':
        this.context.name = 'expertResult'
        break
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ListIdexlab/ListIdexlab.vue